import ContextMenuElementWrapper from "./ContextMenuElementWrapper";

const ContextMenuSubgroup = ({ items }) => {
	return (
		<div>
			{items.map((elementSettings, index) => {
				if (elementSettings.isVisible === false) {
					return <span key={index}></span>;
				} else {
					return <ContextMenuElementWrapper key={index} elementSettings={elementSettings} />;
				}
			})}
		</div>
	);
};

export default ContextMenuSubgroup;
